import React, { Component } from "react"
import { Alert, Button, Form, Radio, Panel } from "react-bootstrap"
import * as firebase from "firebase"
import { signInAnonymously } from "./user"
import TimePicker from "./forms/TimePicker"
import { withRouter } from "react-router-dom"
import "./Settings.css"

class Settings extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isLoading: {},
			hourPicked: 9 * 60,
		}
	}

	handleRadioChange = e => {
		this.setState({
			selectedFrequency: e.target.name,
		})
	}

	handleEmailSubmit = e => {
		e.preventDefault()
		this.submitEmail()
	}

	async submitEmail() {
		this.setState((prevState, props) => ({
			isLoading: true,
		}))
		let err = null
		try {
			const currentUser = await this.getCurrentUser()
			const promises = []
			const db = firebase.firestore()
			const batch = db.batch()
			const frequency = this.state.selectedFrequency
			for (const freq of ["dailyUpdates", "weeklyUpdates", "monthlyUpdates"]) {
				var update
				if (frequency === freq) {
					//const hour = this.refs[frequency].getData() / 3600
					update = {
						//hour: hour,
						updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
						email: currentUser.email,
						active: true,
					}
				} else {
					update = {
						active: false,
						updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
						email: currentUser.email,
					}
				}
				batch.set(
					db
						.collection("cronJobs")
						.doc(freq)
						.collection("uids")
						.doc(currentUser.uid),
					update,
					{
						merge: true,
					}
				)
			}
			promises.push(batch.commit())
			await Promise.all(promises)
		} catch (error) {
			err = error.message
			throw err
		} finally {
			this.setState((prevState, props) => ({
				error: err,
				saved: true,
				isLoading: false,
			}))
		}
	}

	getCurrentUser() {
		const auth = firebase.auth()
		if (auth.currentUser === null) {
			return signInAnonymously()
		}
		return Promise.resolve(auth.currentUser)
	}

	renderTimeSelect = ref => {
		return (
			<TimePicker
				start="00:00"
				end="23:00"
				step={60}
				value={this.state.hourPicked}
				ref={ref}
				defaultValue={28800}
			/>
		)
	}

	render() {
		const { error, saved, selectedFrequency } = this.state
		return (
			<Panel className="settings">
				<h1>Settings</h1>
				{error ? <Alert bsStyle="danger">{error}</Alert> : null}
				{saved &&
					!error && (
						<Alert bsStyle="info">Your settings have been saved.</Alert>
					)}
				<h2>Portfolio Email</h2>
				<p>Receive an email with your portfolio value on a regular basis.</p>
				<Form inline>
					<Radio
						name="noUpdates"
						checked={selectedFrequency === "noUpdates"}
						value={selectedFrequency}
						onChange={this.handleRadioChange}
					>
						None
					</Radio>
				</Form>
				<Form inline>
					<Radio
						name="dailyUpdates"
						checked={selectedFrequency === "dailyUpdates"}
						value={selectedFrequency}
						onChange={this.handleRadioChange}
					>
						<span>Daily</span>
					</Radio>
				</Form>
				<Form inline>
					<Radio
						name="weeklyUpdates"
						checked={selectedFrequency === "weeklyUpdates"}
						value={selectedFrequency}
						onChange={this.handleRadioChange}
					>
						<span>Weekly</span>
					</Radio>
				</Form>
				<Form inline>
					<Radio
						name="monthlyUpdates"
						checked={selectedFrequency === "monthlyUpdates"}
						value={selectedFrequency}
						onChange={this.handleRadioChange}
					>
						<span>Monthly</span>
					</Radio>
				</Form>
				<Button
					type="submit"
					bsSize="large"
					bsStyle="primary"
					disabled={!selectedFrequency}
					onClick={this.handleEmailSubmit}
				>
					Save
				</Button>
			</Panel>
		)
	}
}

export default withRouter(Settings)



// WEBPACK FOOTER //
// ./src/Settings.js